import { takeEvery, all, put, call } from "redux-saga/effects";
import * as action from "../redux/actionsTypes/Types";
import * as type from "../redux/actionsTypes/Types";
import { dashboardCountData } from "../api/services/DashboardServices";

import { dashboardCountAction } from "../redux/actions/DashboardAction";

function* loaddashboardCount(action) {
  try {
    const { data } = yield call(dashboardCountData, "/user/dashboard/count");
    let payload = {};

    yield put(
      dashboardCountAction(
        type.DASHBOARD_COUNT_TABLE_DATA_SUCCESS,

        (payload = {
          userCount: data.data.userCount,
          cvCount: data.data.cvCount,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      dashboardCountAction(
        type.DASHBOARD_COUNT_TABLE_DATA_FAILED,
        error.response
      )
    );
  }
}

function* dashboardWatch() {
  yield takeEvery(action.DASHBOARD_COUNT_TABLE_DATA_START, loaddashboardCount);
}

export function* dashboardSaga() {
  yield all([dashboardWatch()]);
}
